import { ITEMS_QUANTITY_CHANGED } from '../actionTypes/CartActionTypes';

export const itemsQuantityChangedAction = (payload) => ({
    type: ITEMS_QUANTITY_CHANGED,
    payload,
});

export default { itemsQuantityChangedAction };
